import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService } from '@nebular/theme';
import { NbToastrService } from '@nebular/theme';
// import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { interval, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
// import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { ApiServiceService } from '../../../api-service.service';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SpotlightSearchService } from '../../../services/spotlight-search.service';
import { ConfirmComponent } from '../../../confirm/confirm.component';
// Notifications (uncomment when backend is ready)
// import { NotificationService, AppNotification } from '../../../services/notification.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  appInfo:any;
  loading: boolean = false;
  loading1: boolean = false;
  activeusername: string | null = null;
  logo: string = environment.logo;
  product: string = environment.product;
  sync_status: string = localStorage.getItem('sync_status');
  updated_time: string = localStorage.getItem('updated_time');
  private sipoUserSubscription: Subscription;
  selectedLang: string = localStorage.getItem('preferredLang') || 'en';
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'corporate';
  masterLogin:boolean=false;
  appServerVersion:any;
  appLocalVersion=environment.version;

 // userMenu = [{ title: 'Profile' },{ title: 'Settings' }, { title: 'Log out' }];
  userMenu = [];
  internetStatus: boolean;
  private internetStatusSubscription: Subscription;
  doubleClickToLogoutTooltip: string = '';

  // notifications: AppNotification[] = [];
  // notificationsSlice: AppNotification[] = [];
  // notificationUnreadCount = 0;
  // private readonly notificationSliceSize = 5;

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    // private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private router: Router,
    // private authService: NbAuthService,
    private apiservice: ApiServiceService,
    private toastrService: NbToastrService,
    private translate: TranslateService,
    private spotlightService: SpotlightSearchService,
    private dialogService: NbDialogService
    // private notificationService: NotificationService
  ) {
    this.activeusername = this.apiservice.getAccessUser()?.name ?? null;
    console.log("staff id :",this.apiservice.getAccessUser());

    this.apiservice.loginUser.subscribe((dat) => {
      this.activeusername = dat !== null ? dat?.name : null;
      //console.log(dat);
    }
    );
   
    if( localStorage.getItem('sipo_switch_login'))
    {
      this.masterLogin=true;
    }
    
  }
  initialLoadCompleted: boolean = false;
  ngOnInit() {
    this.setLanguageFromPreference();
    this.updateMenuTranslations();

    //console.log(this.logo);

    this.getSyncStatus('initial');

    this.currentTheme = this.themeService.currentTheme;

    this.apiservice.getUserInfo().subscribe((dat) => {
      this.user = dat['user'];
     // console.log("before value :",this.user);
      localStorage.setItem('sipo_user', JSON.stringify(dat['user']));
      this.appInfo=dat['app_info'];
      this.appServerVersion=dat['app_info']['version_number'];
      // console.log("appServerVersion :",this.appServerVersion);
      // console.log("appLocalVersion :",this.appLocalVersion);
      localStorage.setItem('admin_app_server_version',this.appServerVersion);
      localStorage.setItem('admin_app_local_version',this.appLocalVersion);
      if(this.appServerVersion != this.appLocalVersion){
        // Open confirmation dialog to ask user if they want to update
        const dialogRef = this.dialogService.open(ConfirmComponent, {
          context: {
            type: 'info',
            alertmsg: 'A new version is available ('+this.appServerVersion+'). Do you want to update to get the latest changes?',
            btntrue: 'Update Now',
            btnfalse: 'Close'
          },
          closeOnBackdropClick: false,
          closeOnEsc: false
        });

        dialogRef.onClose.subscribe((confirmed: boolean) => {
          if (confirmed) {
            // User confirmed - perform hard reload to get latest version
            this.toastrService.success('Updating to latest version...', 'App Update');
            setTimeout(() => {
              this.hardReload();
            }, 1000);
          } else {
            // User cancelled - stay with current version
            this.toastrService.info('You are using the current version. You can update later from the menu.', 'App Update');
          }
        });
      }
    },
    (err) => {
        // Handle error scenarios
        console.log(err);
      
    }
    );

    this.apiservice.sipoUser.subscribe((dat) => {
      this.user = dat? dat : null;
      //console.log("after value :",this.user);
    }
    );

    this.internetStatusSubscription = this.apiservice.internetStatus$.subscribe((status) => {
      this.internetStatus = status;
      if(this.internetStatus == true && this.initialLoadCompleted == true){
        this.apiservice.toastrSuccess(this.translate.instant('header.networkStatus'), this.translate.instant('header.internetConnected'));
      }
      else if(this.internetStatus == false && this.initialLoadCompleted == true){
        this.apiservice.toastrError(this.translate.instant('header.networkStatus'), this.translate.instant('header.internetDisconnected'));
      }
    });
    

    this.apiservice.checkStaffLogin().subscribe((dat: any) => {
       const isStaff = dat?.stafflogin?.is_staff_login === 1;
       this.apiservice.setStaffLoginRequired(isStaff);
      this.updateMenuTranslations();
     });

    interval(60000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.verifyStaffPinExpiry());

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    // Initial expiry check
    this.verifyStaffPinExpiry();

    this.menuService.onItemClick().subscribe((event) => {
      const userLogoutTitle = this.translate.instant('header.userLogout');
      const fullLogoutTitle = this.translate.instant('header.logout');

      if (event.item.title === userLogoutTitle) {
        this.handleUserLogout();

      } else if (event.item.title === fullLogoutTitle) {
        this.logout();

      } else if (event.item.title === this.translate.instant('header.profile')) {
        this.router.navigateByUrl('/pages/profile');
      
      } else if (event.item.title === this.translate.instant('header.switchToMaster')) {
        this.backToMaster();
      }    
       else if (event.item.title === this.translate.instant('header.storeSettings')) {
        this.router.navigateByUrl('/pages/user-basics');
      }
      else if (event.item.title === 'Sync data') {
        this.forcePush();
      }

    });

    this.getReportSettings();
    this.initialLoadCompleted = true;

    // this.notificationService.getNotifications().subscribe((list) => {
    //   this.notifications = list;
    //   this.notificationsSlice = list.slice(0, this.notificationSliceSize);
    //   this.notificationUnreadCount = list.filter((n) => !n.read).length;
    // });

    // Subscribe to language changes to update menu translations
    this.translate.onLangChange.subscribe(() => {
      this.updateMenuTranslations();
    });
    
    // Initialize tooltip text
    this.doubleClickToLogoutTooltip = this.translate.instant('header.doubleClickToLogout');
    // this.forceEnglish();
  }

  updateMenuTranslations() {
    const profileTitle = this.translate.instant('header.profile');
    const storeSettingsTitle = this.translate.instant('header.storeSettings');
    const userLogoutTitle = this.translate.instant('header.userLogout');
    const fullLogoutTitle = this.translate.instant('header.logout');
    this.doubleClickToLogoutTooltip = this.translate.instant('header.doubleClickToLogout');

    this.userMenu = [
      { title: profileTitle, icon: 'person-outline' },
      { title: storeSettingsTitle, icon: 'settings-outline' },
      { title: 'Sync data', icon: 'sync-outline' },
    ];

    if (this.apiservice.isStaffLogin()) {
      this.userMenu.push({ title: userLogoutTitle, icon: 'log-out-outline' });
    }

    this.userMenu.push({ title: fullLogoutTitle, icon: 'power-outline' });

    if( localStorage.getItem('sipo_switch_login'))
    {
      this.userMenu.push({title: this.translate.instant('header.switchToMaster'), icon:'swap-outline'});
    }
  }


  backToMaster(){
    let token= localStorage.getItem('sipo_master_token');
    if(token){
      this.router.navigateByUrl('auth/tck-login?token='+token);
      localStorage.removeItem('sipo_master_token');
      localStorage.removeItem('sipo_switch_login');
    }
  }


  logout(){
        localStorage.removeItem('sync_status');
        localStorage.removeItem('updated_time');
        localStorage.removeItem('report_from');
        localStorage.removeItem('report_to');
        localStorage.removeItem('reportVersion');
        this.apiservice.clearStaffPinExpiry();
        this.apiservice.logout();
        this.apiservice.updateLoggedUser();
        this.apiservice.updateSipoUser();
      this.router.navigateByUrl('/auth/logout');
  }

  private handleUserLogout(): void {
    this.apiservice.expireStaffPinSession();
    this.router.navigateByUrl('/auth/user-login');
  }


  getReportSettings(){
    this.apiservice.getReportSettings().subscribe((res:any)=>{
      //console.log(res);
      if(res['data'])
      {
        localStorage.setItem('report_from',res['data']['report_start']);
        localStorage.setItem('report_to',res['data']['report_end']);
        localStorage.setItem('reportVersion',res['data']['version']);
      }
      else
      {
        let start = "03:00";
        let end = "03:00";
        localStorage.setItem('report_from',start);
        localStorage.setItem('report_to',end);
      }
    },
    (err)=>{
      console.log(err);
    }
    );
  }

  forcePush() {
    this.toastrService.warning(this.translate.instant('header.started'), this.translate.instant('header.syncingChanges'));
    this.loading = true;
    this.loading1 = true;
    this.apiservice.forcePush().subscribe((dat) => {
      this.loading = false;
      //console.log('check Point', dat);
      let status = dat['Status'];
      this.getSyncStatus();
    },
      (err) => {
        this.toastrService.danger(this.translate.instant('header.failed'), this.translate.instant('header.syncFailed'));
        this.loading = false;
      }
    );


    this.apiservice.productDataSync().subscribe((dat) => {
      this.loading1 = false;
      // this.toastrService.success("Completed", 'Menu data sync');
    }, (err) => {
      console.log(err);
      this.toastrService.danger(this.translate.instant('header.failed'), this.translate.instant('header.menuDataSyncFailed'));
      this.loading1 = false;
    }
    );

  }

  getSyncStatus(type = null) {
    this.apiservice.getSyncStatus().subscribe((dat) => {
      //console.log(dat);
      let status = dat['Status'];
      localStorage.setItem('sync_status',status);
      localStorage.setItem('updated_time',dat['updatedat']);
      this.sync_status = status;
      this.updated_time = dat['updatedat'];
      if(type != 'initial'){
      if (status === 'PROGRESS') {
        this.loading = true;
        setTimeout(() => {
          this.getSyncStatus(); // Call the function again after 1 minute
        }, 60000); // 1 minute = 60,000 milliseconds
      }
      else if(status === 'COMPLETED' || status === 'FCOMPLETED'){
        this.toastrService.success(this.translate.instant('header.completed'), this.translate.instant('header.syncCompleted'));
        this.loading = false;
      }
      else if( status === 'FAILED' ){
        this.toastrService.danger(this.translate.instant('header.syncFailedRetry'), this.translate.instant('header.syncFailed'));
        this.loading = false;
      }
    }
    },
      (err) => {
        console.log(err);
      }
    );
  }


  gotoStart() {
    this.router.navigateByUrl('/auth/user-login');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.sipoUserSubscription) {
      this.sipoUserSubscription.unsubscribe();
    }
    if (this.internetStatusSubscription) {
      this.internetStatusSubscription.unsubscribe();
    }
    
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  setLanguageFromPreference() {
    const lang = localStorage.getItem('preferredLang') || 'en';
    console.log("Language :",lang);
    this.selectedLang=lang;
    if (lang === 'en') {
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + window.location.hostname + ';';
      window.location.hash = '';
    } else {
      document.cookie = `googtrans=/en/${lang};path=/;domain=${window.location.hostname}`;
      window.location.hash = `#googtrans(en|${lang})`;
    }
  }

  googleTranslateSwitchLang() {
    localStorage.setItem('preferredLang', this.selectedLang);
    if (this.selectedLang === 'en') {
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + window.location.hostname + ';';
      window.location.hash = '';
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    } else {
      let target = 'zh-TW';
     
      document.cookie = `googtrans=/en/${target};path=/;domain=${window.location.hostname}`;
      window.location.hash = `#googtrans(en|${target})`;
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  }

  forceEnglish() {
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + window.location.hostname + ';';
    window.location.hash = '';
  }

  openSpotlight() {
    this.spotlightService.open();
  }

  private verifyStaffPinExpiry(): void {
    if (!this.apiservice.isStaffLogin() || !this.apiservice.isStaffPinVerified()) {
      return;
    }

    if (this.apiservice.isStaffPinExpired()) {
      this.toastrService.warning('Session expired. Please re-enter your PIN.', 'User Login');
      this.apiservice.expireStaffPinSession();
      this.router.navigateByUrl('/auth/user-login');
    }
  }

  /**
   * Performs a hard reload of the page to bypass cache and get the latest version
   */
  private hardReload(): void {
    // Method 1: Use location.replace with cache-busting query parameter
    // This forces a full reload bypassing browser cache
    const url = new URL(window.location.href);
    url.searchParams.set('_v', Date.now().toString());
    window.location.replace(url.toString());
    
    // Fallback: If replace doesn't work, use location.href with cache-busting
    // This ensures the page reloads even if replace is blocked
    setTimeout(() => {
      window.location.href = url.toString();
    }, 100);
  }
}
